"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithRecordSetFeature = void 0;
var foundation_1 = require("@deqo/foundation");
var RecordSetRepository_1 = require("./RecordSetRepository");
var RecordSetTypes_1 = require("./RecordSetTypes");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WithRecordSetFeature(Base) {
    return /** @class */ (function (_super) {
        __extends(RecordSetFeature, _super);
        function RecordSetFeature() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
            _this.recordSets = new RecordSetRepository_1.RecordSetRepository();
            _this.inNotifyRecord = function (_a) {
                var _b = __read(_a, 2), recordSetName = _b[0], record = _b[1];
                var rs = _this.recordSets.get(recordSetName) || _this.recordSets.add(recordSetName);
                record = rs.replace(record);
                _this.router.emit('recordUpdate', [recordSetName, record]);
            };
            _this.pod.receive('notify_record', _this.inNotifyRecord);
            return _this;
        }
        RecordSetFeature.prototype.subscribeRecordSet = function (recordSetName) {
            if (this.destroyed())
                return;
            this.recordSets.add(recordSetName);
            this.pod.send('subscribe_record_set', [recordSetName]);
        };
        RecordSetFeature.prototype.getRecordSetNames = function () {
            return this.recordSets.getAll().map(function (x) { return x.name; });
        };
        RecordSetFeature.prototype.getRecordSet = function (recordSetName) {
            var _a, _b;
            return (_b = (_a = this.recordSets.get(recordSetName)) === null || _a === void 0 ? void 0 : _a.getAll()) !== null && _b !== void 0 ? _b : null;
        };
        RecordSetFeature.prototype.getRecord = function (recordSetName, id) {
            var _a;
            var rs = this.recordSets.get(recordSetName);
            return (_a = rs === null || rs === void 0 ? void 0 : rs.getOne(id)) !== null && _a !== void 0 ? _a : null;
        };
        RecordSetFeature.prototype.patchRecord = function (recordSetName, patch) {
            var _a;
            (0, foundation_1.assert)('id' in patch && typeof (patch.id) === 'string', 'patch must have an id (string) property');
            if (this.readonly || this.destroyed()) {
                return (_a = this.getRecord(recordSetName, patch.id)) !== null && _a !== void 0 ? _a : patch;
            }
            // If we are submitting a patch before subscribing, subscribe first
            if (!this.recordSets.get(recordSetName)) {
                this.subscribeRecordSet(recordSetName);
            }
            // Clean patch of invalid entries (NaN, etc)
            patch = RecordSetTypes_1.RecordData.clean(patch);
            // Submit patch
            var reductionKey = Object.keys(patch).sort().join('/');
            this.pod.send('patch_record', [recordSetName, patch], reductionKey);
            // Patch locally and return new version
            return this.recordSets.get(recordSetName).patch(patch);
        };
        RecordSetFeature.prototype.on = function (type, to) {
            return this.router.on(type, to);
        };
        return RecordSetFeature;
    }(Base));
}
exports.WithRecordSetFeature = WithRecordSetFeature;
